import { PushNotifications } from '@capacitor/push-notifications'
import { removePusher, registerPushToken } from './capicatorDetectBothMobile.js'

let pushListeners = []

async function registerForPushNotifications (matrixClient, asynccallbackTokenFn) {
  // console.log('RJMDEBUG001 registering push notification listeners')

  await removeAllPushListners()

  pushListeners.push(PushNotifications.addListener('registration', async (token) => {
    console.log('RJMDEBUG001 Push token received:', token.value)
    await registerPushToken({ matrixClient, tokenValue: token.value })
    await asynccallbackTokenFn({ tokenValue: token.value })
  }))

  pushListeners.push(PushNotifications.addListener('registrationError', (err) => {
    console.error('RJMDEBUG001 Push registration error:', err)
  }))

  // When a notification is tapped
  pushListeners.push(PushNotifications.addListener('pushNotificationActionPerformed', (action) => {
    console.log('RJMDEBUG001 Notification action performed', action)
    const roomId = action.notification.data?.notification?.room_id

    if (roomId) {
      console.log('RJMDEBUG001 Navigating to room:', roomId)
      // Assuming you use Vue Router (Quasar), this might look like:
      // router.push({ name: 'chat', params: { roomId } })
    } else {
      console.warn('RJMDEBUG001 No room_id found in push notification.')
    }
  }))

  // console.log('RJMDEBUG001 registerForPushNotifications about to request permissions')
  PushNotifications.requestPermissions().then(permStatus => {
    if (permStatus.receive === 'granted') {
      console.log('RJMDEBUG001 Sucessfully granted push notification permission')
    } else {
      console.log('RJMDEBUG001 ERROR Push permission not granted.')
      return
    }
    (async () => {
      console.log('RJMDEBUG001 Registiring push notifications async')
      await PushNotifications.register()
    })()
  }).catch(error => {
    console.log('RJMDEBUG001 Error requesting push permissions:', error)
  })
}

async function removeAllPushListners () {
  for (const listener of pushListeners) {
    await listener.remove()
  }

  pushListeners = []
}

async function notifyMatrixConnectionDetails (connectionDetails) {
  const plugin = window.Capacitor.Plugins.FirebasePushToken
  if (!plugin) {
    console.log('RJMDEBUG001 FirebasePushToken plugin not available')
  } else {
    await plugin.receiveMatrixConnectionDetails(connectionDetails)
  }
}

function transmitMessage ({ txnId, processData, roomId, messageType, content, matrix, globalEventBus }) {
  const plugin = window.Capacitor.Plugins.TransmissionExecutor
  if (!plugin) {
    console.log('RJMDEBUG001 TransmissionExecutor plugin not available')
  } else {
    plugin.transmitMessage({ txnId, processData, roomId, messageType, content })
  }
}

async function notifyMatrixLogout (matrixClient) {
  await removeAllPushListners()

  const plugin = window.Capacitor.Plugins.FirebasePushToken
  if (!plugin) {
    console.log('RJMDEBUG001 FirebasePushToken plugin not available')
  } else {
    await removePusher(matrixClient, plugin)
    await plugin.notifyMatrixLogout()
  }
}

export default {
  registerForPushNotifications,
  registerPushToken,
  notifyMatrixConnectionDetails,
  transmitMessage,
  notifyMatrixLogout
}
